import {mapGetters, mapActions, mapMutations} from 'vuex'

export default {
    computed: {
        ...mapGetters('countries', [
            'countries',
            'country'
        ]),
    },

    methods: {

        ...mapActions('countries', {
            getOneCountry: 'getOne',
            getAllCountries: 'getAll'
        }),

        ...mapMutations([
            'setGlobalLoading'
        ]),

        async getCountryById(countryId) {
            try {
                this.setGlobalLoading(true);
                await this.getOneCountry({id: countryId})
            } catch(e) {
                console.error(e)
            } finally {
                this.setGlobalLoading(false);
            }
        },
    }
}
